import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DesktopActivityInput } from '../../ActivityInput/desktop/DesktopActivityInput';
import { DesktopLocationInput } from '../../LocationInput/desktop/DesktopLocationInput';
import { useSearch } from '../use-search';
import { SmallSpinner } from '../../../decorators/spinner';
import { ArrowStylizedLg } from '../../../icons';

export const DesktopSearchForm = () => {
  const {
    currentLocale,
    handleSubmit,
    activityValue,
    setActivityValue,
    locationValue,
    setLocationValue,
    activeInput,
    setActiveInput,
    setValidateActivity,
    setValidateLocation,
    fetchingGeoData,
    defaultActivity,
    defaultLocation
  } = useSearch();

  return (
    <form className="container-fluid" onSubmit={handleSubmit}>
      <div className="flex space-between middle">
        <div className="search_form_input_wrap">
          <DesktopActivityInput
            value={activityValue}
            setValue={setActivityValue}
            defaultActivity={defaultActivity}
            formActive={!!activeInput}
            activeInput={activeInput}
            setActiveInput={setActiveInput}
            setValidator={setValidateActivity}
          />
        </div>
        <div className="search_form_input_wrap">
          <DesktopLocationInput
            value={locationValue}
            setValue={setLocationValue}
            defaultLocation={defaultLocation}
            formActive={!!activeInput}
            currentLocale={currentLocale}
            activeInput={activeInput}
            setActiveInput={setActiveInput}
            setValidator={setValidateLocation}
          />
        </div>
        <div>
          <button className="btn btn-primary relative" disabled={fetchingGeoData}>
            <div className={`flex middle ${!fetchingGeoData ? 'visible' : 'invisible'}`}>
              <FormattedMessage
                id='shared_components.search-form.search'
                defaultMessage='Search'
              />
              <ArrowStylizedLg style={{ fontSize: '24px' }} className="margin-md-left" />
            </div>
            <div className={`${fetchingGeoData ? 'visible' : 'invisible'}`}>
              <SmallSpinner show />
            </div>
          </button>
        </div>
      </div>
    </form>
  );
};
